module.exports = __webpack_public_path__ + "img/37_54.a7474c36.png";